<template>
  <div id="app">
    <NavigationBar v-if="!hideNavbar" :class="{ 'm-0': $route.name !== 'Login' }"/>
    <router-view/>
  </div>
</template>

<script>
import NavigationBar from './components/NavigationBar.vue';

export default {
  components: { NavigationBar },
  computed: {
    hideNavbar() {
      const hide = ['Login', 'PasswordForgotten'];
      return hide.includes(this.$route.name);
    },
  },
};
</script>
